import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'

import ImpactService from 'src/services/impacts.service'
import { QUERY_KEYS } from 'src/constants'

export const useInitialImpactCode = () => {
  const { accountId } = useParams()
  return useQuery(
    [QUERY_KEYS.IMPACT_INITIAL_CODE, accountId],
    () => (accountId ? ImpactService.getInitialCode(accountId) : null),
    {
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
    },
  )
}
